@if (loading()) {
  <glxy-loading-spinner></glxy-loading-spinner>
} @else if (configs().length === 0) {
  <glxy-empty-state>
    <glxy-empty-state-title>
      {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.EMPTY_STATE_TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.EMPTY_STATE_DESCRIPTION' | translate }}</p>
    <glxy-empty-state-actions>
      <button mat-flat-button color="primary" (click)="onAddNew()">
        <mat-icon>add</mat-icon>
        {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.ADD_NEW' | translate }}
      </button>
    </glxy-empty-state-actions>
  </glxy-empty-state>
} @else if (dataSource) {
  <glxy-table-container [dataSource]="dataSource" [columns]="columns" [pageSizeOptions]="[10, 25, 50]">
    <glxy-table-content-header
      [showFilters]="false"
      [showSearch]="false"
      [showSort]="false"
      [showColumnArrange]="false"
      [showActions]="false"
    >
      <button mat-flat-button color="primary" (click)="onAddNew()" after-search>
        <mat-icon>add</mat-icon>
        {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.ADD_NEW' | translate }}
      </button>
    </glxy-table-content-header>

    <table mat-table>
      <tr mat-header-row *matHeaderRowDef="[]"></tr>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CONFIG_NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let config">
          <strong>{{ config.name }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="categories">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.CATEGORIES_COUNT' | translate }}
        </th>
        <td mat-cell *matCellDef="let config">
          {{ config.categories.length }} {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.LABELS' | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.LAST_UPDATED' | translate }}
        </th>
        <td mat-cell *matCellDef="let config">{{ formatDate(config.updated) }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let config">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onEdit(config)">
              <mat-icon>edit</mat-icon>
              <span>{{ 'COMMON.EDIT' | translate }}</span>
            </button>
            <button mat-menu-item (click)="onDelete(config)">
              <mat-icon>delete</mat-icon>
              <span>{{ 'COMMON.DELETE' | translate }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: []"></tr>
    </table>

    @if (configs().length === 0) {
      <glxy-empty-state [size]="'small'">
        <glxy-empty-state-hero>
          <mat-icon>label</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>
          {{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.EMPTY_STATE_TITLE' | translate }}
        </glxy-empty-state-title>
        <p>{{ 'ADMINISTRATION.EMAIL_LABELING_SETTINGS.EMPTY_STATE_DESCRIPTION' | translate }}</p>
      </glxy-empty-state>
    }
  </glxy-table-container>
}
